export default __webpack_public_path__ + "static/media/A13.24ad5328.png";